/**
 * sampleImage
 */
import 'intersection-observer';
import {gsap, Cubic} from 'gsap'

export default class sakeGold {

  constructor() {
    // クラス名
    this.id = 'sampleImage';
    this.el = document.getElementById(this.id);

    if (this.el) {
      this.init();
    }
  }

  init() {
    //
    this.isStarted = false;
    this.images = this.el.querySelectorAll('img');
    this.current = 0;
    this.max = this.images.length;

    // イベント
    const options = {
      root: null,
      rootMargin: '-20% 0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver(this.intersect.bind(this), options);
    this.observer.observe(this.el);
  }

  intersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting === true) {
        // 表示スタート
        requestAnimationFrame(this.start.bind(this));
        this.observer.unobserve(entry.target);
      }
    });
  }

  start() {
    if (this.isStarted) return;
    this.isStarted = true;

    gsap.fromTo(this.images[0], {
      opacity: 0,
    }, {
      duration: 1.0,
      opacity: 1,
      ease: Cubic.easeOut
    });
    this.current = 0;

    setTimeout(this.slide.bind(this), 3500);

    this.clearIntersect();
  }

  slide() {
    gsap.to(this.images[this.current], {
      duration: 1.0,
      opacity: 0,
      ease: Cubic.easeOut
    });

    const next = (this.current + 1) % this.max;

    gsap.fromTo(this.images[next], {
      opacity: 0,
    }, {
      duration: 1.0,
      opacity: 1,
      ease: Cubic.easeOut
    });

    this.current = next;

    setTimeout(this.slide.bind(this), 3500);
  }

  clearIntersect() {
    this.observer.disconnect();
    delete this.observer;
  }
}
